import React from 'react'
import { Badge } from 'rsuite'
import { Cell } from 'rsuite-table'

type RowData = {
  [key: string]: string | boolean
}

type PaymentModeCellProps = {
  rowData?: RowData
  dataKey: string
}

const defaultProps = {
  rowData: undefined
}

const MODE_CONFIG: Record<
  string,
  { label: string; bg: string; color: string }
> = {
  MONTHLY: { label: 'Monthly', bg: '#E8F4FD', color: '#1976D2' },
  ANNUAL: { label: 'Annual', bg: '#EDE7F6', color: '#7B1FA2' }
}

const FALLBACK_CONFIG = { label: '-', bg: '#E9EDF5', color: '#6C778B' }

const PaymentModeCell: React.FC<PaymentModeCellProps> = ({
  rowData,
  dataKey,
  ...props
}) => {
  const mode = rowData?.[dataKey] as string
  const config = MODE_CONFIG[mode] ?? {
    ...FALLBACK_CONFIG,
    label: mode ?? '-'
  }

  return (
    <Cell {...props}>
      <Badge
        style={{
          backgroundColor: config.bg,
          color: config.color,
          padding: '3px 10px 3px 5px'
        }}
        content={
          <>
            <Badge style={{ backgroundColor: config.color, margin: '0 7px' }} />
            {config.label}
          </>
        }
      />
    </Cell>
  )
}

PaymentModeCell.defaultProps = defaultProps

export default PaymentModeCell
